import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
// import { PolicyPrivacyComponent } from './policy-privacy/policy-privacy/policy-privacy.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  // { path: 'privacy-policy', component: PolicyPrivacyComponent },
  { path: 'terms-conditions', component: TermsConditionsComponent },

  {
    path: 'policy-privacy',
    loadChildren: () => import('./policy-privacy/policy-privacy.module').then(m => m.PolicyPrivacyModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
